const initialState = {
  isFetching: false,
  isFetched: false,
  isError: false,
  isSuccess: false,
  depositAccount: null,
  data: []
}

export const ACTION_TYPES = {
  CUSTOMER_ACCOUNT_REQUEST: 'CUSTOMER_ACCOUNT_REQUEST',
  CUSTOMER_ACCOUNT_SUCCESS: 'CUSTOMER_ACCOUNT_SUCCESS',
  CUSTOMER_ACCOUNT_ERROR: 'CUSTOMER_ACCOUNT_ERROR'
}

export const getCustomerAccount = () => ({
  type: ACTION_TYPES.CUSTOMER_ACCOUNT_REQUEST
})

const getDepositAccount = data => {
  const accounts = data || []
  const deposits = accounts.filter(it => it.accountType === 'Deposit')

  return deposits.length ? deposits[0] : null
}

const customerAccount = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.CUSTOMER_ACCOUNT_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.CUSTOMER_ACCOUNT_SUCCESS:
      return {
        ...state,
        data: payload.data,
        isFetching: false,
        isFetched: true,
        isError: false,
        isSuccess: true,
        depositAccount: getDepositAccount(payload.data)
      }
    case ACTION_TYPES.CUSTOMER_ACCOUNT_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        isError: true,
        isSuccess: false,
        depositAccount: null
      }
    default:
      return state
  }
}

export default customerAccount
